export function dialog() {
	if (document.querySelector('dialog')) {
		const openDialog = document.querySelectorAll('.open-dialog')
		const closeDialog = document.querySelectorAll('.close-dialog')
		const dialog = document.querySelectorAll('dialog')

		openDialog.forEach((item) => {
			item.addEventListener('click', () => {
				if (document.activeElement) {
					document.activeElement.blur()
				}
				document.querySelector('dialog[id*="' + item.getAttribute('data-dialog') + '"').showModal()
			})
		})

		closeDialog.forEach((item) => {
			item.addEventListener('click', () => {
				document.querySelector('dialog[id*="' + item.getAttribute('data-dialog') + '"').close()
			})
		})

		dialog.forEach((item) => {
			item.addEventListener('click', (e) => {
				const dialogDimensions = item.getBoundingClientRect()

				if (!e.target.form && (e.clientX < dialogDimensions.left || e.clientX > dialogDimensions.right || e.clientY < dialogDimensions.top || e.clientY > dialogDimensions.bottom)) {
					item.close()
				}
			})
		})
	}
}
